import * as React from 'react';
import { Segment, Table as UITable } from 'semantic-ui-react';
import { StatisticsTableDescription } from '~/InfoCard/Details/StatisticsTableDescription';
var parseThousands = function (number) {
    return number !== undefined ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : 'No data';
};
export var Monthly = function (_a) {
    var detail = _a.detail, headers = _a.headers, yearCounter = _a.yearCounter, children = _a.children;
    return (<div data-testid={detail.type}>
		{children}
		<Segment.Group>
			<UITable celled striped structured unstackable className='sticky-column-1' size='small'>
				<UITable.Header>
					<UITable.Row>
						<UITable.HeaderCell />
						{Object.entries(yearCounter).map(function (_a) {
            var key = _a[0], value = _a[1];
            return (<UITable.HeaderCell colSpan={value} key={key} textAlign='center'>
								{key}
							</UITable.HeaderCell>);
        })}
					</UITable.Row>
					<UITable.Row>
						{/* @TODO - This is nasty hack how to fix headers naming in the market share info card.
    Proper fix would be create new type of statistics, which would have different columns and headers names accordingly*/}
						<UITable.HeaderCell data-testid='record-header'>
							{detail.title === 'Tržní podíl dle nahlášených cen původce' || detail.title === 'Tržní podíl dle ODTD'
            ? 'Brand'
            : 'Balení'}
						</UITable.HeaderCell>
						{headers.map(function (header) { return (<UITable.HeaderCell data-testid='record-header' key={header} textAlign='center'>
								{new Intl.DateTimeFormat('cs-CZ', { month: 'long' }).format(new Date(header))}
							</UITable.HeaderCell>); })}
					</UITable.Row>
				</UITable.Header>
				<UITable.Body>
					{detail.statistics.map(function (statistics, j) { return (<UITable.Row data-testid='record' key={j}>
							<UITable.Cell singleLine>{statistics.title}</UITable.Cell>
							{headers.map(function (header) { return (<UITable.Cell singleLine key={header} textAlign='right'>
									{parseThousands(statistics.records[header])}
								</UITable.Cell>); })}
						</UITable.Row>); })}
				</UITable.Body>
				{detail.overallStatistics !== undefined ? (<UITable.Footer>
						<UITable.Row data-testid='total'>
							<UITable.Cell>Total</UITable.Cell>
							{headers.map(function (header) { return (<UITable.Cell singleLine key={header} textAlign='right'>
									{parseThousands(detail.overallStatistics !== undefined ? detail.overallStatistics[header] : undefined)}
								</UITable.Cell>); })}
						</UITable.Row>
					</UITable.Footer>) : null}
			</UITable>
		</Segment.Group>
		<StatisticsTableDescription />
	</div>);
};
